module.exports = __webpack_public_path__ + "static/media/eqsymbol.1bd1a177.jpg";